/**
 * tpl-mat-gallery-plus (2026-10-29)
 *  d3 labelled dots: tap a label, jump to that slide.
 *  d7 fullscreen viewer: tap a slide; swipe, pinch, double-tap, swipe down to close.
 *  d2 window loupe: press and hold (250 ms) on a photo for a 2.5x round magnifier.
 * Vanilla, no libraries. Loaded by sections/tpl-mat-gallery.liquid.
 */
(function () {
  'use strict';
  if (window.tplMatGalleryPlus) return;
  window.tplMatGalleryPlus = true;

  var HOLD_MS = 250, MOVE_PX = 8, ZOOM = 2.5, BIG = 2048, HINT_KEY = 'tpl_mg_hint_seen';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function noMotion() { return !!(reduced && reduced.matches); }
  function track(name, params) {
    try { if (window.tplTrack) window.tplTrack(name, params || {}); } catch (e) { /* analytics never breaks UI */ }
  }
  function store(get, key, val) {
    try { return get ? window.localStorage.getItem(key) : window.localStorage.setItem(key, val); } catch (e) { return null; }
  }
  function bigUrl(src) {
    if (!src) return src;
    if (/([?&])width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + BIG);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + BIG;
  }
  function imgOf(slide) { return slide.querySelector('img.tpl-mg__img'); }
  function vidOf(slide) { return slide.querySelector('[data-mg-film] video'); }
  function srcOf(img) { return img.currentSrc || img.src; }
  function reflow(el) { return el.offsetWidth; }

  /* ── viewer (d7) ─────────────────────────────────────────── */
  var viewer = null;

  function openViewer(items, startAt) {
    if (viewer) return;
    var opener = document.activeElement;
    var overlay = document.createElement('div');
    overlay.className = 'tpl-mgx';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Gallery');
    overlay.innerHTML =
      '<div class="tpl-mgx__track"></div>' +
      '<button type="button" class="tpl-mgx__close" aria-label="Close"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 3l12 12M15 3L3 15"/></svg></button>' +
      '<button type="button" class="tpl-mgx__nav tpl-mgx__nav--prev" aria-label="Previous"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 3L5 9l6 6"/></svg></button>' +
      '<button type="button" class="tpl-mgx__nav tpl-mgx__nav--next" aria-label="Next"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 3l6 6-6 6"/></svg></button>' +
      '<div class="tpl-mgx__bar"><span class="tpl-mgx__count"></span><span class="tpl-mgx__cap" aria-live="polite"></span></div>' +
      '<div class="tpl-mgx__thumbs" role="group" aria-label="Choose a photo"></div>';
    var tr = overlay.querySelector('.tpl-mgx__track');
    var countEl = overlay.querySelector('.tpl-mgx__count');
    var capEl = overlay.querySelector('.tpl-mgx__cap');
    var thumbsEl = overlay.querySelector('.tpl-mgx__thumbs');
    var closeBtn = overlay.querySelector('.tpl-mgx__close');
    var prevBtn = overlay.querySelector('.tpl-mgx__nav--prev');
    var nextBtn = overlay.querySelector('.tpl-mgx__nav--next');

    var imgs = items.map(function (it) {
      var slide = document.createElement('div');
      slide.className = 'tpl-mgx__slide';
      if (it.video) {
        /* 3 Nov 2026 (owner): gallery films open here too, playing, instead of pausing on tap */
        var v = document.createElement('video');
        v.className = 'tpl-mgx__img tpl-mgx__vid';
        v.muted = true; v.loop = true; v.playsInline = true;
        v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
        v.preload = 'auto';
        if (it.small) v.poster = it.small;
        if (it.alt) v.setAttribute('aria-label', it.alt);
        if (noMotion()) v.controls = true;
        v.src = it.video;
        slide.appendChild(v);
        tr.appendChild(slide);
        return v;
      }
      var im = document.createElement('img');
      im.className = 'tpl-mgx__img';
      im.alt = it.alt || '';
      im.draggable = false;
      im.src = it.small;
      slide.appendChild(im);
      tr.appendChild(slide);
      return im;
    });
    var thumbs = items.map(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tpl-mgx__thumb';
      b.setAttribute('aria-label', (it.label || 'Photo') + ', ' + (i + 1) + ' of ' + items.length);
      var ti = document.createElement('img');
      ti.alt = '';
      ti.draggable = false;
      if (it.small) ti.src = it.small;
      b.appendChild(ti);
      b.addEventListener('click', function () { goTo(i, true); });
      thumbsEl.appendChild(b);
      return b;
    });
    if (items.length < 2) thumbsEl.hidden = true;
    var upgraded = {};
    function upgrade(i) {
      if (i < 0 || i >= items.length || upgraded[i]) return;
      upgraded[i] = true;
      if (items[i].video) return;
      var hi = new Image();
      hi.onload = function () { if (viewer) imgs[i].src = items[i].big; };
      hi.src = items[i].big;
    }

    var idx = startAt, W = 0, H = 0;
    var s = 1, tx = 0, ty = 0;

    function apply(img) {
      img.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + s + ')';
    }
    function clamp() {
      var im = imgs[idx];
      var lx = Math.max(0, (im.offsetWidth * s - W) / 2), ly = Math.max(0, (im.offsetHeight * s - H) / 2);
      tx = Math.max(-lx, Math.min(lx, tx));
      ty = Math.max(-ly, Math.min(ly, ty));
    }
    function setZoomed() { overlay.classList.toggle('is-zoomed', s > 1.01); }
    function resetZoom(img, animate) {
      s = 1; tx = 0; ty = 0;
      if (animate && !noMotion()) { img.style.transition = 'transform .22s ease'; setTimeout(function () { img.style.transition = ''; }, 260); }
      apply(img); setZoomed();
    }
    function label() {
      countEl.textContent = (idx + 1) + ' / ' + items.length;
      capEl.textContent = items[idx].label || '';
      thumbs.forEach(function (b, i) {
        if (i === idx) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      var t = thumbs[idx];
      if (t && thumbsEl.scrollWidth > thumbsEl.clientWidth) {
        thumbsEl.scrollTo({ left: t.offsetLeft - (thumbsEl.clientWidth - t.offsetWidth) / 2, behavior: noMotion() ? 'auto' : 'smooth' });
      }
      prevBtn.style.visibility = idx === 0 ? 'hidden' : '';
      nextBtn.style.visibility = idx === items.length - 1 ? 'hidden' : '';
      playCurrent();
    }
    /* only the film on screen plays; reduced motion leaves it to the controls */
    function playCurrent() {
      imgs.forEach(function (el, i) {
        if (el.tagName !== 'VIDEO') return;
        if (i === idx && !noMotion()) { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
        else el.pause();
      });
    }
    function measure() { W = tr.clientWidth; H = tr.clientHeight; }
    function goTo(i, smooth) {
      i = Math.max(0, Math.min(items.length - 1, i));
      tr.scrollTo({ left: i * W, behavior: smooth && !noMotion() ? 'smooth' : 'auto' });
    }
    var sched = false;
    tr.addEventListener('scroll', function () {
      if (sched) return; sched = true;
      requestAnimationFrame(function () {
        sched = false;
        var n = W ? Math.round(tr.scrollLeft / W) : idx;
        if (n !== idx && n >= 0 && n < items.length) {
          resetZoom(imgs[idx], false);
          idx = n; label(); upgrade(idx); upgrade(idx + 1); upgrade(idx - 1);
          track('tpl_gallery_fullscreen_slide', { slide: idx + 1, label: items[idx].label || '' });
        }
      });
    }, { passive: true });

    /* gestures: pinch, pan, double-tap, swipe-down-to-close */
    var ptrs = {};
    var pinch = null, pan = null, drag = null, lastTap = { t: 0, x: 0, y: 0 };
    function pt(e) { return { x: e.clientX, y: e.clientY }; }
    function ids() { return Object.keys(ptrs); }
    function dist(a, b) { return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y)); }
    function zoomAt(px, py, ns, s0, tx0, ty0) {
      var cx = W / 2, cy = H / 2;
      s = ns;
      tx = px - cx - (ns / s0) * (px - cx - tx0);
      ty = py - cy - (ns / s0) * (py - cy - ty0);
      clamp(); apply(imgs[idx]); setZoomed();
    }
    tr.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      ptrs[e.pointerId] = pt(e);
      var k = ids();
      if (k.length === 2) {
        var a = ptrs[k[0]], b = ptrs[k[1]];
        pinch = { d: dist(a, b), s: s, tx: tx, ty: ty, mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2 };
        pan = null; drag = null;
      } else if (k.length === 1) {
        pan = { x: e.clientX, y: e.clientY, tx: tx, ty: ty, t: Date.now(), moved: 0 };
        drag = null;
        if (e.pointerType === 'mouse' && s > 1.01) { try { tr.setPointerCapture(e.pointerId); } catch (er) { /* ok */ } }
      }
    });
    tr.addEventListener('pointermove', function (e) {
      if (!ptrs[e.pointerId]) return;
      ptrs[e.pointerId] = pt(e);
      var k = ids();
      if (pinch && k.length >= 2) {
        var a = ptrs[k[0]], b = ptrs[k[1]];
        var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
        var ns = Math.max(1, Math.min(5, pinch.s * dist(a, b) / pinch.d));
        zoomAt(mx, my, ns, pinch.s, pinch.tx + (mx - pinch.mx), pinch.ty + (my - pinch.my));
        return;
      }
      if (!pan) return;
      var dx = e.clientX - pan.x, dy = e.clientY - pan.y;
      pan.moved = Math.max(pan.moved, Math.abs(dx), Math.abs(dy));
      if (s > 1.01) {
        tx = pan.tx + dx; ty = pan.ty + dy; clamp(); apply(imgs[idx]);
      } else if (drag || (dy > 10 && dy > Math.abs(dx) * 1.2)) {
        drag = { dy: dy };
        imgs[idx].style.transform = 'translate3d(0,' + dy + 'px,0)';
        overlay.style.background = 'rgba(17,17,17,' + Math.max(0.15, 1 - dy / 420).toFixed(2) + ')';
      }
    });
    function endPtr(e, cancelled) {
      if (!ptrs[e.pointerId]) return;
      delete ptrs[e.pointerId];
      var k = ids();
      if (pinch && k.length < 2) {
        pinch = null;
        if (s < 1.05) resetZoom(imgs[idx], true);
        if (k.length === 1) pan = { x: ptrs[k[0]].x, y: ptrs[k[0]].y, tx: tx, ty: ty, t: Date.now(), moved: 99 };
        else pan = null;
        return;
      }
      if (!pan || k.length) return;
      var p = pan; pan = null;
      if (drag) {
        var d = drag.dy; drag = null;
        if (!cancelled && (d > 110 || (d > 50 && Date.now() - p.t < 220))) { closeUI(); return; }
        imgs[idx].style.transition = noMotion() ? '' : 'transform .2s ease';
        apply(imgs[idx]); overlay.style.background = '';
        setTimeout(function () { imgs[idx].style.transition = ''; }, 240);
        return;
      }
      if (!cancelled && p.moved < 10 && Date.now() - p.t < 300) {
        var now = Date.now();
        if (now - lastTap.t < 320 && dist(lastTap, { x: e.clientX, y: e.clientY }) < 30) {
          lastTap.t = 0;
          if (s > 1.01) { resetZoom(imgs[idx], true); }
          else {
            if (!noMotion()) imgs[idx].style.transition = 'transform .22s ease';
            zoomAt(e.clientX, e.clientY, 2.5, 1, 0, 0);
            setTimeout(function () { imgs[idx].style.transition = ''; }, 260);
          }
        } else { lastTap = { t: now, x: e.clientX, y: e.clientY }; }
      }
    }
    tr.addEventListener('pointerup', function (e) { endPtr(e, false); });
    tr.addEventListener('pointercancel', function (e) { endPtr(e, true); });
    tr.addEventListener('wheel', function (e) {
      e.preventDefault();
      var ns = Math.max(1, Math.min(5, s * Math.exp(-e.deltaY * 0.0025)));
      if (ns === s) return;
      zoomAt(e.clientX, e.clientY, ns, s, tx, ty);
      if (s < 1.02) resetZoom(imgs[idx], false);
    }, { passive: false });

    /* lock, trap, history */
    document.documentElement.classList.add('tpl-mgx-open');
    var htmlOv = document.documentElement.style.overflow, bodyOv = document.body.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    var inerted = [];
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (!el.inert && el.tagName !== 'SCRIPT') { el.inert = true; inerted.push(el); }
    });
    document.body.appendChild(overlay);
    var pushed = false;
    try { history.pushState({ tplmgx: 1 }, ''); pushed = true; } catch (er) { /* ok */ }

    var done = false;
    function teardown() {
      if (done) return; done = true;
      window.removeEventListener('popstate', onPop);
      document.removeEventListener('keydown', onKey, true);
      window.removeEventListener('resize', onResize);
      function remove() {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        inerted.forEach(function (el) { el.inert = false; });
        document.documentElement.classList.remove('tpl-mgx-open');
        document.documentElement.style.overflow = htmlOv;
        document.body.style.overflow = bodyOv;
        viewer = null;
        try { if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true }); } catch (er) { /* ok */ }
      }
      overlay.classList.remove('is-open');
      if (noMotion()) remove(); else setTimeout(remove, 200);
    }
    function onPop() { teardown(); }
    function closeUI() {
      if (pushed && history.state && history.state.tplmgx) { pushed = false; history.back(); setTimeout(teardown, 120); }
      else teardown();
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeUI(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(idx + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(idx - 1, true); }
      else if (e.key === 'Home') { e.preventDefault(); goTo(0, true); }
      else if (e.key === 'End') { e.preventDefault(); goTo(items.length - 1, true); }
      else if (e.key === 'Tab') {
        var f = [closeBtn, prevBtn, nextBtn].concat(thumbs).filter(function (b) { return b.offsetParent !== null && b.style.visibility !== 'hidden'; });
        if (!f.length) return;
        var i = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus();
      }
    }
    function onResize() { measure(); goTo(idx, false); }
    window.addEventListener('popstate', onPop);
    document.addEventListener('keydown', onKey, true);
    window.addEventListener('resize', onResize);
    closeBtn.addEventListener('click', closeUI);
    prevBtn.addEventListener('click', function () { goTo(idx - 1, true); });
    nextBtn.addEventListener('click', function () { goTo(idx + 1, true); });

    viewer = { close: closeUI };
    measure();
    goTo(idx, false);
    label(); upgrade(idx); upgrade(idx + 1); upgrade(idx - 1);
    reflow(overlay);
    overlay.classList.add('is-open');
    closeBtn.focus({ preventScroll: true });
  }

  /* ── loupe (d2) ──────────────────────────────────────────── */
  var loupeEl = null, loupeTracked = false;
  function ensureLoupe() {
    if (!loupeEl) {
      loupeEl = document.createElement('div');
      loupeEl.className = 'tpl-loupe';
      loupeEl.setAttribute('aria-hidden', 'true');
      document.body.appendChild(loupeEl);
    }
    return loupeEl;
  }

  /* ── per gallery ─────────────────────────────────────────── */
  function initGallery(root) {
    if (root.dataset.tplPlus === '1') return;
    var trk = root.querySelector('[data-mg-track]');
    if (!trk) return;
    root.dataset.tplPlus = '1';
    var slides = Array.prototype.slice.call(trk.querySelectorAll('[data-mg-slide]'));
    slides.forEach(function (sl) { if (imgOf(sl)) sl.classList.add('has-plus'); });

    /* d3 dots: tap a label, jump to that slide; aria-current follows scroll */
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mg-dot]'));
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        if (!slides[i]) return;
        trk.scrollTo({ left: slides[i].offsetLeft, behavior: noMotion() ? 'auto' : 'smooth' });
        track('tpl_gallery_dot', { slide: i + 1, label: slides[i].getAttribute('data-mg-label') || '' });
      });
    });
    var ds = false;
    function paintDots() {
      ds = false;
      var best = 0, bd = Infinity;
      slides.forEach(function (sl, i) { var dd = Math.abs(sl.offsetLeft - trk.scrollLeft); if (dd < bd) { bd = dd; best = i; } });
      dots.forEach(function (d, i) { if (i === best) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    if (dots.length) {
      trk.addEventListener('scroll', function () { if (!ds) { ds = true; requestAnimationFrame(paintDots); } }, { passive: true });
      paintDots();
    }

    /* d2 + d7 gestures on image slides */
    var suppressUntil = 0, lastTouch = 0, st = null, timer = 0, loupeOn = false, raf = 0, lastPt = null;
    var hint = null;

    function dismissHint() {
      if (!hint) return;
      var h = hint; hint = null; h.classList.remove('is-on');
      setTimeout(function () { if (h.parentNode) h.parentNode.removeChild(h); }, 450);
    }
    function geometry(slide) {
      var img = imgOf(slide); if (!img || !img.naturalWidth) return null;
      var r = img.getBoundingClientRect();
      var sc = Math.max(r.width / img.naturalWidth, r.height / img.naturalHeight);
      var rw = img.naturalWidth * sc, rh = img.naturalHeight * sc;
      return { r: r, rw: rw, rh: rh, ox: (r.width - rw) / 2, oy: (r.height - rh) / 2, img: img };
    }
    function paintLoupe() {
      raf = 0;
      if (!loupeOn || !st || !lastPt) return;
      var g = st.geo, el = loupeEl, R = el.clientWidth / 2;
      var x = lastPt.x, y = lastPt.y;
      var cy = st.touch ? y - R - 28 : y;
      cy = Math.max(R + 4, cy);
      var cx = Math.max(R + 4, Math.min(window.innerWidth - R - 4, x));
      var px = Math.max(0, Math.min(g.r.width, x - g.r.left)), py = Math.max(0, Math.min(g.r.height, y - g.r.top));
      el.style.transform = 'translate3d(' + (cx - R - 2) + 'px,' + (cy - R - 2) + 'px,0)';
      el.style.backgroundSize = (g.rw * ZOOM) + 'px ' + (g.rh * ZOOM) + 'px';
      el.style.backgroundPosition = (R - (px - g.ox) * ZOOM) + 'px ' + (R - (py - g.oy) * ZOOM) + 'px';
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(paintLoupe); }
    function startLoupe() {
      timer = 0;
      if (!st) return;
      var g = geometry(st.slide);
      if (!g) return;
      st.geo = g;
      var el = ensureLoupe();
      var small = srcOf(g.img), big = bigUrl(small);
      el.style.backgroundImage = 'url("' + small + '")';
      var hi = new Image();
      hi.onload = function () { if (loupeOn && st && st.geo === g) el.style.backgroundImage = 'url("' + big + '")'; };
      hi.src = big;
      loupeOn = true;
      document.documentElement.classList.add('tpl-loupe-live');
      if (navigator.vibrate && st.touch) { try { navigator.vibrate(8); } catch (e) { /* ok */ } }
      paintLoupe();
      el.classList.add('is-on');
      if (!loupeTracked) { loupeTracked = true; track('tpl_loupe', { input: st.touch ? 'touch' : 'mouse' }); }
      store(false, HINT_KEY, '1');
      dismissHint();
    }
    function stopLoupe() {
      clearTimeout(timer); timer = 0;
      if (loupeOn) {
        loupeOn = false;
        suppressUntil = Date.now() + 450;
        if (loupeEl) loupeEl.classList.remove('is-on');
        document.documentElement.classList.remove('tpl-loupe-live');
      }
      st = null;
    }
    function begin(e, x, y, touch) {
      var sl = e.target.closest && e.target.closest('[data-mg-slide]');
      if (!sl || !imgOf(sl)) return false;
      st = { slide: sl, x: x, y: y, touch: touch };
      lastPt = { x: x, y: y };
      clearTimeout(timer);
      timer = setTimeout(startLoupe, HOLD_MS);
      return true;
    }
    trk.addEventListener('touchstart', function (e) {
      lastTouch = Date.now();
      if (e.touches.length !== 1) { stopLoupe(); return; }
      begin(e, e.touches[0].clientX, e.touches[0].clientY, true);
    }, { passive: true });
    trk.addEventListener('touchmove', function (e) {
      lastTouch = Date.now();
      if (!st) return;
      var t = e.touches[0];
      lastPt = { x: t.clientX, y: t.clientY };
      if (loupeOn) { if (e.cancelable) e.preventDefault(); schedule(); return; }
      if (Math.abs(t.clientX - st.x) > MOVE_PX || Math.abs(t.clientY - st.y) > MOVE_PX) { clearTimeout(timer); timer = 0; st = null; }
    }, { passive: false });
    ['touchend', 'touchcancel'].forEach(function (n) {
      trk.addEventListener(n, function () { lastTouch = Date.now(); stopLoupe(); }, { passive: true });
    });
    trk.addEventListener('contextmenu', function (e) {
      if (e.target.closest && e.target.closest('.has-plus') && (loupeOn || Date.now() - lastTouch < 800)) e.preventDefault();
    });
    trk.addEventListener('dragstart', function (e) { if (e.target.tagName === 'IMG') e.preventDefault(); });

    trk.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || Date.now() - lastTouch < 700) return;
      begin(e, e.clientX, e.clientY, false);
    });
    document.addEventListener('mousemove', function (e) {
      if (!st || st.touch) return;
      lastPt = { x: e.clientX, y: e.clientY };
      if (loupeOn) schedule();
      else if (Math.abs(e.clientX - st.x) > MOVE_PX || Math.abs(e.clientY - st.y) > MOVE_PX) { clearTimeout(timer); timer = 0; st = null; }
    });
    document.addEventListener('mouseup', function () { if (st && !st.touch) stopLoupe(); });
    window.addEventListener('blur', stopLoupe);

    /* tap -> fullscreen. A hold that opened the loupe never opens it. */
    function openFrom(slide) {
      var items = [], start = 0;
      slides.forEach(function (sl) {
        var im = imgOf(sl), vd = im ? null : vidOf(sl);
        if (!im && !vd) return;
        if (sl === slide) start = items.length;
        var lab = sl.getAttribute('data-mg-label') || '';
        if (vd) {
          var srcEl = vd.querySelector('source');
          items.push({ video: vd.currentSrc || (srcEl && srcEl.src) || vd.src, small: vd.getAttribute('poster') || '', alt: vd.getAttribute('aria-label') || sl.getAttribute('aria-label') || '', label: lab });
          return;
        }
        var small = srcOf(im);
        items.push({ small: small, big: bigUrl(small), alt: im.alt, label: lab });
      });
      if (!items.length) return;
      track('tpl_gallery_fullscreen', { slide: start + 1, label: items[start].label });
      openViewer(items, start);
    }
    trk.addEventListener('click', function (e) {
      if (Date.now() < suppressUntil) { e.preventDefault(); return; }
      var sl = e.target.closest && e.target.closest('[data-mg-slide]');
      if (!sl || !(imgOf(sl) || vidOf(sl)) || e.target.closest('a,button')) return;
      openFrom(sl);
    });
    trk.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.target !== trk) return;
      var best = null, bd = Infinity;
      slides.forEach(function (sl) { var d = Math.abs(sl.offsetLeft - trk.scrollLeft); if (d < bd && imgOf(sl)) { bd = d; best = sl; } });
      if (best) openFrom(best);
    });

    /* one-time hint */
    if (!store(true, HINT_KEY) && slides[0] && imgOf(slides[0]) && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () {
          if (store(true, HINT_KEY) || viewer) return;
          hint = document.createElement('span');
          hint.className = 'tpl-mg__hint';
          hint.textContent = 'Hold to look closer';
          slides[0].appendChild(hint);
          reflow(hint); hint.classList.add('is-on');
          store(false, HINT_KEY, '1');
          setTimeout(dismissHint, 3600);
        }, 1200);
      }, { threshold: 0.6 });
      io.observe(slides[0]);
    }
  }

  function boot() { document.querySelectorAll('[data-tpl-mat-gallery]').forEach(initGallery); }
  boot();
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('load', boot);
})();
